<template>
  <div v-show="afficherNavigation">
    <template v-if="barreNavigation == 'compte'">
      <!-- Point d'entrée de la barre navigation PCU -->
      <div v-if="afficherPCU" v-show="enteteChargee" id="barreNavigation"></div>
      <nav v-if="barreNavigation == 'compte'" :class="{ 'position-relative': afficherPCU }">
        <div class="nav-conteneur d-flex align-items-center nav-hauteur" :class="theme">
          <div
            v-if="afficherLienRetour && !cacherLienPrecedent"
            class="box col en-tete-pr-0 en-tete-pl-1"
          >
            <a data-precedent="precedent" class="lien-retour" @click="$router.go(-1)">
              <svg-icon :icon-name="iconeLienRetour" fill="transparent" />
              {{ $t('precedent') }}
            </a>
          </div>
          <div
            class="col en-tete-px-1"
            :class="afficherLienRetour ? 'text-center' : 'text-md-left'"
          >
            <WithRoot :show="!mixinEnvironnement_inAppMobile">
              <a
                v-if="themeLogoNav !== 'invisible'"
                :href="jel_nettoyerLienExterne($t('hyperlien.portailLotoQuebec'))"
              >
                <svg-icon
                  class="logo-lq"
                  :class="isSmallerScreen ? theme : themeLogoNav"
                  :icon-name="logoLQ"
                />
                <label class="sr-only">{{ $t('retourAccueil') }}</label>
              </a>
            </WithRoot>
          </div>

          <!-- Afficher les routes uniquement en développment -->
          <div v-if="mixinEnvironnement_isDeveloppement && actualRoutes" class="col-0 en-tete-px-0">
            <router-link
              v-if="!isSessionEstOuverte()"
              v-slot="{ href, navigate }"
              to="/connexion"
              custom
            >
              <a :href="href" class="text-secondary" title="Connexion" @click="navigate"
                >&#x2714;</a
              >
            </router-link>
            <router-link
              v-if="isSessionEstOuverte()"
              v-slot="{ href, navigate }"
              to="/compte/deconnexion"
              custom
            >
              <a :href="href" class="text-secondary" title="Déconnexion" @click="navigate">
                &#x2718;
              </a>
            </router-link>
          </div>

          <!-- Afficher les routes uniquement en développment -->
          <div v-if="mixinEnvironnement_isDeveloppement && actualRoutes" class="col-4 en-tete-px-0">
            <b-form-group class="my-1" label-sr-only :label="$t('page')" label-for="routeOption">
              <b-form-select
                id="routeOption"
                v-model="routeOptionSelected"
                name="routeOption"
                @change="changerRoute"
              >
                <b-form-select-option
                  v-for="item in actualRoutes"
                  :key="item['@id']"
                  :value="item['@path'] != undefined ? item['@path'].replace('/jel', '') : ''"
                >
                  {{ item.title }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </div>

          <div v-if="mixinEnvironnement_isDeveloppement" class="col-2 languages">
            <b-form-group class="my-1" label-sr-only :label="$t('langue')" label-for="langueOption">
              <b-form-select
                id="langueOption"
                v-model="currentLanguage"
                name="langueOption"
                class="form-control"
                @change="clickLanguage(currentLanguage)"
              >
                <b-form-select-option
                  v-for="language in languages"
                  :key="language"
                  :value="language"
                >
                  {{ language }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </div>

          <div
            v-if="!aide.isAideActif && mixinEnvironnement_isNavigateurSupporte"
            class="col en-tete-pl-0 pr-1 d-flex justify-content-end"
          >
            <div
              v-if="themeAideNav == 'themeLienSuperieurDroit'"
              class="justify-content-end lien-superieur-droit"
            >
              <span v-if="libSuperieurDroit1">{{ libSuperieurDroit1 }}&nbsp;</span>
              <a :href="lienSuperieurDroit" class="lien-aide">{{ libSuperieurDroit2 }}</a>
            </div>
            <b-link
              v-else
              :href="lienBoutonAide"
              :target="targetBoutonAide"
              data-aide="aide"
              class="btnVide lien-aide row mx-0 en-tete-px-0 align-items-center d-flex flex-row flex-nowrap"
              :class="isSmallerScreen ? theme : themeAideNav"
              @click="toggleAide()"
            >
              {{ $t('aide') }}
              <span class="d-none d-sm-block ml-2 icone-aide">?</span>
            </b-link>
          </div>
        </div>
      </nav>
    </template>
    <template v-else>
      <!-- Point d'entrée de la barre navigation PCU -->
      <div id="barreNavigation"></div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import session from '@/services/api/compte/session';
import i18n from '@/js/i18n';

// Helpers
import {
  getLanguages,
  getCurrentLanguage,
  getQueryParamsValue,
  inMgnl,
  removeQueryParam,
} from '@/helpers/AppHelpers';
import { changeLanguage, isPreferencesPath } from '@/helpers/RouteHelpers';

import { bus } from '@/main';

import WithRoot from '@/components/base/WithRoot';

export default {
  name: 'Navigation',
  components: {
    WithRoot,
  },
  mixins: [mixinEnvironnement],
  data() {
    return {
      currentLanguage: getCurrentLanguage(),
      enteteChargee: false,
      languages: getLanguages(),
      routeOptionSelected: this.$router.currentRoute.path,

      afficherLienRetour: false,

      afficherNavigation: false,
      afficherPCU: false,
      barreNavigation: null, // Est null seulement au premier appel
      cacherLienPrecedent: false,
      libSuperieurDroit1: '',
      libSuperieurDroit2: '',
      lienBoutonAide: '',
      lienSuperieurDroit: '',
      targetBoutonAide: '',
      theme: '',
      themeAideNav: '',
      themeLogoNav: '',
      typeBoutonAide: null,
    };
  },
  computed: {
    ...mapState('routes', ['routes']),
    ...mapState(['aide']),
    actualRoutes() {
      return this.routes;
    },
    isSmallerScreen() {
      return this.$mq != 'lg' && this.$mq != 'xl' && this.$mq != 'xxl';
    },
    logoLQ() {
      return this.theme == 'compteFonce' ? 'logo-lq-dark' : 'logo-lq-light';
    },
    iconeLienRetour() {
      return this.theme == 'compteFonce' ? 'fleche-gauche-claire' : 'fleche-gauche';
    },
  },
  mounted() {
    const self = this;
    //  événement du bus pour changer des champs d'en-tete
    bus.$on('NouvellePageMounted', (args) => {
      self.listenerNouvellePageMounted(args);
    });
    bus.$on('hasRetour', (hasRetour) => {
      self.afficherLienRetour = hasRetour;
    });
    bus.$on('urlAutreLangue', (url) => {
      if (typeof majAutreLangue == 'function') {
        // eslint-disable-next-line no-undef
        majAutreLangue(url);
      }
    });

    // Bouton En savoir plus dans wysiwyg dans limite de depot choix
    bus.$on('triggerToggleAide', this.toggleAide);
    // Mettre à jour le tag lang html
    document.documentElement.setAttribute('lang', i18n.locale);
    // Minimalement nécessaire pour lancer bingo dans la langue courante
    document.body.classList.add(i18n.locale);

    // Ajout pour IE 11 pour avoir le logo LQ en haut de page à gauche
    if (!this.mixinEnvironnement_isNavigateurSupporte) {
      this.afficherNavigation = true;
      this.themeLogoNav = 'logo-lq-light';
    }
    // listener que la barre PCU est bien chargée
    document.addEventListener('ejEventHeaderLoad', this.ejEventHeaderLoadListener);
  },
  beforeDestroy() {
    bus.$off('NouvellePageMounted', this.listenerNouvellePageMounted);
    bus.$off('hasRetour');
    bus.$off('triggerToggleAide', this.toggleAide);
    document.removeEventListener('ejEventHeaderLoad', this.ejEventHeaderLoadListener);
  },
  methods: {
    listenerNouvellePageMounted(args) {
      const urlParams = new URLSearchParams(window.location.search);
      const lang = getQueryParamsValue('lang');
      const pathAutreLangue = this.$store.getters['routes/getPathAutreLangue'](
        window.location.pathname.slice(3)
      );

      const urlAutreLangue = `/${i18n.locale == 'fr' ? 'en' : 'fr'}${pathAutreLangue}`;

      // On redirige vers l'autre langue les pages Bingo si le QueryParam lang est présent
      if (/\/bingo\//i.test(window.location.pathname) && lang && i18n.locale !== lang) {
        // Redirige vers urlAutreLangue
        window.location.href = urlAutreLangue;
      } else {
        if (lang) {
          // Enlève le QueryParam 'lang'
          removeQueryParam('lang');
        }

        // Afficher PCU est utilisé uniquement dans la page club-casino-privileges
        if (
          !this.mixinEnvironnement_inAppMobile &&
          ((!inMgnl && this.barreNavigation == null && (args.barreNavigation ?? 'pcu') == 'pcu') ||
            args.afficherPCU === true)
        ) {
          // chargement du JS de la barre PCU
          this.chargementBarrePCU(urlAutreLangue);
        } else {
          try {
            if (typeof majAutreLangue == 'function') {
              // eslint-disable-next-line no-undef
              majAutreLangue(urlAutreLangue);
            }
            if (!this.$root.$data.fistloadPage) {
              // Ne pas relancer ejConnect pendant un flux Auth0 Action :
              // la présence de ?state= indique que l'utilisateur est en cours
              // de redirection post-login (ex: securiser-mon-compte?state=...).
              // Appeler ejConnect.start() ici provoquerait un nouveau flux
              // d'authentification qui invalide l'action state en cours.
              // const isAuth0ActionRedirect = new URLSearchParams(window.location.search).has('state');
              // if (!isAuth0ActionRedirect) {
              // eslint-disable-next-line no-undef
              ejConnect.start();
              // }
            } else {
              this.$root.$data.fistloadPage = false;
            }
          } catch (error) {
            console.error('Erreur demarrage', error);
          }
        }

        this.afficherNavigation = args.afficherNavigation;
        this.afficherPCU = args.afficherPCU;
        this.barreNavigation = args.barreNavigation ?? 'pcu';
        this.cacherLienPrecedent = args.cacherLienPrecedent;
        this.libSuperieurDroit1 = args.libSuperieurDroit1;
        this.libSuperieurDroit2 = args.libSuperieurDroit2;
        this.lienBoutonAide = args.lienBoutonAide;
        this.lienSuperieurDroit = args.lienSuperieurDroit;
        this.targetBoutonAide = args.targetBoutonAide;
        this.theme = args.theme;
        this.themeAideNav = args.themeAideNav ?? args.theme;
        this.themeLogoNav = args.themeLogoNav ?? args.theme;
        this.typeBoutonAide = args.typeBoutonAide ?? 'defaut';
      }
    },
    chargementBarrePCU(path) {
      try {
        // chargement du JS
        chargementScript(
          `/mel/.resources/lq-entete-commun/webresources/js/charger-entete.js?site_id=EJ&lang=${i18n.locale}&trx=true&tagid=barreNavigation`,
          function () {
            // eslint-disable-next-line no-undef
            setUriAutreLangue(path);
          }
        );
        this.fetchPrefsSiSessionEstOuverte();
      } catch (error) {
        console.error("Erreur lors du chargement de l'entête", error);
      }
    },
    clickLanguage() {
      changeLanguage(this.currentLanguage);
    },
    changerRoute() {
      if (this.$router.currentRoute.path != this.routeOptionSelected) {
        this.$router.push({ path: this.routeOptionSelected }).catch((err) => {
          // On catch pour éviter:
          // Uncaught (in promise) Error: Problem handling something: Error: Redirected when going from "?" to "?" via a navigation guard.
        });
      }
    },
    toggleAide() {
      if (!this.lienBoutonAide) {
        this.$store.dispatch('aide/toggleAide');
      }
    },
    isSessionEstOuverte() {
      return this.$route.fullPath && session.sessionEstOuverte();
    },
    fetchPrefsSiSessionEstOuverte() {
      if (session.sessionEstOuverte() && isPreferencesPath()) {
        this.$store.dispatch('preferences/getPreferences');
      }
    },
    ejEventHeaderLoadListener() {
      this.enteteChargee = true;
    },
  },
};

function chargementScript(url, callback) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'mel';
  if (script.readyState) {
    // IE
    script.onreadystatechange = function () {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    // Autre
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
</script>

<style lang="scss" scoped>
#barreNavigation {
  width: 100%;
  margin: 0px auto;
}

.logo-lq {
  width: calc(1.1rem + 3vw);
  height: calc(1.1rem + 3vw);
  max-height: 2.5rem;
}
nav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 21;
}

a.default-router-link {
  display: inline-block;
  padding: 10px;
  text-decoration: none;
  color: $couleur-pied-de-page;
}
a.default-router-link:hover {
  color: $couleur-default-router-link;
}

a.default-router-link {
  display: inline-block;
  padding: 10px;
  text-decoration: none;
  color: $couleur-pied-de-page;
}
a.default-router-link:hover {
  color: $couleur-default-router-link;
}

.lien-aide {
  color: $couleur-primaire;
  font-size: 1.1rem;
  font-family: $font-graphik-semibold;
  text-decoration: none;
  padding-left: 6px;
  padding-right: 6px;
}

.icone-aide {
  border-radius: 50%;

  background: $couleur-primaire;
  color: white;
  text-align: center;

  height: 2.5rem;
  width: 2.5rem;
  line-height: 2.5rem;

  font-size: 1.5rem;
}

.nav-hauteur {
  line-height: 46px !important;
  height: 46px !important;

  @include media-breakpoint-up(md) {
    line-height: 64px !important;
    height: 64px !important;
  }
}

.lien-superieur-droit {
  line-height: initial;
}

.lien-superieur-droit .lien-aide {
  @include media-breakpoint-down(xs) {
    font-size: 0.9em;
  }
}

.compteFonce .lien-superieur-droit .lien-aide {
  color: #ffffff;
}

/*
@include media-breakpoint-down(sm) {
  nav {
    padding: 0;
  }

  div.col {
    text-align: center; //lorsqu'en mobile, aligner les éléments de l'entête au centre
  }
  div.col:nth-child(1) {
    text-align: left; //permet au premier élément de l'entête d'être aligné à gauche
  }
  .lien-aide {
    font-family: $font-graphik-medium;
    font-size: 1rem;
  }
}
*/
</style>
